// import { useTranslation } from "react-i18next";
import { BsInstagram, BsTelephone } from "react-icons/bs";
import { CiYoutube } from "react-icons/ci";
import { RiWhatsappLine, RiBaseStationLine } from "react-icons/ri";
import { MdOutlineMailOutline } from "react-icons/md";
import "./index-footer.css";
import { whatsAppRedirect } from "../../hooks/common";
import { epContactInfo } from "../../hooks/ep-contact-info";

function Footer() {
  const date = new Date().getFullYear();
  // const { t } = useTranslation("footer");

  return (
    <>
      <footer className="footer" id="contato">
        <div className="container">
          <div className="footer-main">
            {/* BRAND */}

            <div className="footer-brand">
              <div className="footer-logo">
                <img className="footer-logo-symbol" src="/images/logo-book.png" alt="Logo Book" />
                <div>
                  <strong>ESCRITA PRÁTICA</strong>
                  <small>Professora Iasmyn Souza Louis</small>
                </div>
              </div>

              <p>
                Aulas online, correções e mentorias para quem quer dominar a
                escrita e alcançar seus objetivos.
              </p>

              <div className="social-links">
                <a 
                  className="social-icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href={epContactInfo.instagram}><BsInstagram /></a>
                <a 
                  className="social-icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href={epContactInfo.youtube}><CiYoutube /></a>
                <a
                  className="social-icon-link"
                  target="_blank"
                  rel="noreferrer"
                  onClick={whatsAppRedirect}
                  href="#contato"
                  >
                  <RiWhatsappLine/>
                </a>
              </div>
            </div>

            <div className="footer-column">
              <h3>NAVEGAÇÃO</h3>

              <a href="/">Início</a>
              <a href="#sobre-a-professora">Sobre</a>
              <a href="#cursos">Cursos</a>
              <a href="#como-funciona">Como funciona</a>
              <a href="#depoimentos">Depoimentos</a>
              <a href="#faq">FAQ</a>
            </div>

            <div className="footer-column">
              <h3>NOSSOS SERVIÇOS</h3>

              <a href="redacao-enem">Redação ENEM</a>
              <a href="correcoes-para-concursos">Correções para Concursos</a>
              <a href="producao-textual-para-vestibulares">Produção Textual para Vestibulares</a>
              <a href="mentorias-individuais">Mentoria Individual para Educação e Saúde</a>
              <a href="correcao-com-feedback">Correção Personalizada com Feedback</a>
              {/* ========================================= */}
              {/* <a href="termos-de-contratacao">Termos de contratação</a> */}
              <a href="modalidades">Modalidades</a>
            </div>

            <div className="footer-column contact">
              <h3>CONTATO</h3>

              <a href="tel:+5522988592932"><BsTelephone/> { epContactInfo.telefone } </a>
              <a href="mailto:contato@escritapratica.com.br"> <MdOutlineMailOutline/> {epContactInfo.email} </a>
              {/* contato@escritapratica.com.br */}
              <a  
                target="_blank"
                rel="noreferrer"
                onClick={whatsAppRedirect}
                href="#contato">
                <RiBaseStationLine/> Atendimento online
              </a>
            </div>
          </div>

          <div className="footer-bottom">
            <span>
              © {date} Escrita Prática | Todos os direitos reservados
            </span>
            <div>
              <a href="privacy-policy">Política de Privacidade</a>
              <span>|</span>
              <a href="terms-of-use">Termos de Uso</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;